import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import stageConfig from 'app/StageConfig';

function Phone(props) {
  const image = props.phone.imagePhoneUrl.split('\\');
  const filename = image[image.length - 1];

  return (
    <div
      className={`phone-container ${props.phone.modelId === props?.selectedPhone?.modelId ? 'selected' : ''}`}
      onClick={() => props.onClick(props.phone)}>
      <div className='image-container'>
        <Image className='image' src={`${stageConfig.staticWebSiteUrl}/idfImages/images/${filename}`} alt='Main Image' />
      </div>
      <div className='text-container'>
        {/* <span className='brand-text'>apple</span> */}
        <span className='model-text'>{props.phone.modelName}</span>
        {/* <span className='model-size'>{props.phone.storage}</span> */}
        <div className='divided-price-text'>
          <span className='price'>{` ₪${props.phone.priceCash}`}</span>
          <span className='counts'>בתשלום אחד</span>
        </div>
        <span className='full-price-text'>
          {`או ₪${props.isLeasing ? props.phone.priceLeasing : props.phone.priceNormal}`}X{' '}
          {props.isLeasing ? 18 : props.phone.paymentsNormal}
        </span>
      </div>
    </div>
  );
}

export default Phone;
